import Karyawan from "./Karyawan";
import Role from "./Role";
import BaseModel from "./_BaseModel";

export default class User extends BaseModel {
    public readonly ucode?: string;
    public ucode_karyawan?: string;
    public kode_karyawan?: string;
    public nama_karyawan?: string;
    public karyawan?: Karyawan;
    public username?: string;
    public password?: string;
    public aktif?: boolean = true;
    public ucode_role?: string;
    public kode_role?: string;
    public nama_role?: string;
    public role?: Role;
    public is_new?: boolean = false;

    public constructor(
        ucode?: string
    ) {
        super();
        this.ucode = ucode;
    }
}